import {
  Inserter,
  SessionRole,
  DragAndDropContext,
  TinymcePortal,
  RouterPageNotFound,
  ErrorBoundry,
  PartAdmin,
  PartMenu,
  Wrapper,
  Icon,
  Link,
} from "nystem-components";

import "./index.css";

const Index = () => (
  <ErrorBoundry fallback={<Inserter match="*" source="/page/view/404" />}>
    <DragAndDropContext>
      <TinymcePortal />
      <SessionRole userrole="logged-in">
        <Wrapper className="flex flex-col justify-center items-center ">
          <Link to="/admin">
            <Icon
              icon="gear"
              className="fixed top-0 right-0 w-8 h-8 text-gray-500 z-200 p-2"
            />
          </Link>
        </Wrapper>
      </SessionRole>
      <Wrapper className="bg-white/30 mt-40 min-h-96 md:px-3">
        <PartMenu />
        <PartAdmin />
        <Inserter match="/page/view/*" className="px-3" />
        <RouterPageNotFound limit={5}>
          <Inserter match="*" source="/page/view/404" />
        </RouterPageNotFound>
      </Wrapper>
    </DragAndDropContext>
  </ErrorBoundry>
);

export default Index;
